import { P, FF } from "../../styles/tokens";
import { fmt } from "../../utils/format";

export default function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;

  return (
    <div
      style={{
        background: P.surface,
        border: `1.5px solid ${P.border}`,
        borderRadius: 14,
        padding: "12px 16px",
        fontSize: 12,
        fontFamily: FF,
      }}
    >
      <div style={{ fontWeight: 700, color: P.text, marginBottom: 8 }}>{label}</div>
      {payload.map((p) => (
        <div key={p.name} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: p.color, flexShrink: 0 }} />
          <span style={{ fontWeight: 400, color: P.textSm }}>{p.name}:</span>
          <span style={{ fontWeight: 700, color: P.text }}>{fmt(p.value)}</span>
        </div>
      ))}
    </div>
  );
}
